// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './components/Login';
import PasswordReset from './components/PasswordReset';
import EmailVerificationPending from './components/EmailVerificationPending';
import Licenses from './components/Licenses';
import Users from './components/Users';
import Plugins from './components/Plugins';
import HomeComponent from './components/Home';
import ProtectedRoute from './ProtectedRoute';
import RoleProtectedRoute from './components/RoleProtectedRoute';
import Renewals from './components/Renewals';
import UserDetails from './components/UserDetails';
import Downloads from './components/Downloads';
import MyLicenses from './components/MyLicenses';
import Courses from './components/Courses';
import Lessons from './components/Lessons';
import Learning from './components/Learning';
import CourseView from './components/CourseView';
import Plans from './components/Plans';
import Subscription from './components/Subscription';
import { AuthProvider } from './context/AuthContext';

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Rotas públicas */}
          <Route path="/login" element={<Login />} />
          <Route path="/password-reset" element={<PasswordReset />} />
          <Route path="/email-verification-pending" element={<EmailVerificationPending />} />
          
          {/* Rotas protegidas - Qualquer usuário autenticado */}
          <Route path="/home" element={<ProtectedRoute><HomeComponent /></ProtectedRoute>} />
          <Route path="/licenses" element={<ProtectedRoute><Licenses /></ProtectedRoute>} />
          <Route path="/renewals" element={<ProtectedRoute><Renewals /></ProtectedRoute>} />
          <Route path="/downloads" element={<ProtectedRoute><Downloads /></ProtectedRoute>} />
          <Route path="/my-licenses" element={<ProtectedRoute><MyLicenses /></ProtectedRoute>} />
          <Route path="/subscription" element={<ProtectedRoute><Subscription /></ProtectedRoute>} />
          
          {/* Rotas de Aprendizado - Usuários */}
          <Route path="/learning" element={<ProtectedRoute><Learning /></ProtectedRoute>} />
          <Route path="/learning/course/:courseId" element={<ProtectedRoute><CourseView /></ProtectedRoute>} />
          
          {/* Rotas protegidas - Apenas Administradores */}
          <Route 
            path="/plans" 
            element={
              <ProtectedRoute>
                <RoleProtectedRoute requiredRole="admin">
                  <Plans />
                </RoleProtectedRoute>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/users" 
            element={
              <ProtectedRoute>
                <RoleProtectedRoute requiredRole="admin">
                  <Users />
                </RoleProtectedRoute>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/users/:userId" 
            element={
              <ProtectedRoute>
                <RoleProtectedRoute requiredRole="admin">
                  <UserDetails />
                </RoleProtectedRoute>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/plugins" 
            element={
              <ProtectedRoute>
                <RoleProtectedRoute requiredRole="admin">
                  <Plugins />
                </RoleProtectedRoute>
              </ProtectedRoute>
            } 
          />
          
          {/* Rotas de Aprendizado - Administradores */}
          <Route 
            path="/admin/courses" 
            element={
              <ProtectedRoute>
                <RoleProtectedRoute requiredRole="admin">
                  <Courses />
                </RoleProtectedRoute>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/lessons/:courseId" 
            element={
              <ProtectedRoute>
                <RoleProtectedRoute requiredRole="admin">
                  <Lessons />
                </RoleProtectedRoute>
              </ProtectedRoute>
            } 
          />
            
          <Route path="/" element={<Login />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
